import { SecurityUtils } from "../SecurityUtils";
import { IHashingAlgorithm } from "./IHashingAlgorithm";

type Forge = typeof import("node-forge");

/**
 * Implementace algoritmu SHA-512 pro proudové počítání hashe
 * @includeToDoc
 */
export class Sha512Algorithm implements IHashingAlgorithm {
    public readonly algorithmName: string = "SHA512";
    public readonly maxChunkSize = 16 * 1024;

    private _hasher: any;
    private _hash: Uint8Array;
    private __forgeLoader: Promise<Forge>; //externí knihovna https://github.com/digitalbazaar/forge
    private _forge: Forge;

    public get finished(): boolean {
        return this.result != null;
    }

    public get result(): BufferSource | null {
        if (!this._hash)
            return null;
        return this._hash;
    }

    private async _getForge(): Promise<any> {
        if (!this.__forgeLoader)
            this.__forgeLoader = import("node-forge").then(module => module.default);
        return this.__forgeLoader;
    }

    public async update(data: BufferSource): Promise<void> {
        this._forge = await this._getForge();

        if (!this._hasher)
            this._hasher = this._forge.md.sha512.create();

        const chunk = data instanceof Uint8Array ?
            data :
            data instanceof ArrayBuffer ?
                new Uint8Array(data) :
                new Uint8Array(data.buffer);

        const maxChunkSize = this.maxChunkSize;
        if (chunk.byteLength <= maxChunkSize) {
            // INFO: nepoužívat `forge.util.binary.raw.encode`, jelikož nezvládne větší blok jak ~100k
            this._hasher.update(SecurityUtils.arrayToBinaryEncodedString(chunk));
            return;
        }

        for (let i = 0, size = chunk.byteLength; i < size; i += maxChunkSize) {
            const littleChunk = chunk.slice(i, i + maxChunkSize);
            // INFO: nepoužívat `forge.util.binary.raw.encode`, jelikož nezvládne větší blok jak ~100k
            this._hasher.update(SecurityUtils.arrayToBinaryEncodedString(littleChunk));
        }
    }

    public finish(): void {
        if (!this._forge)
            throw new Error("'finish' called before 'update'");
        this._hash = this._forge.util.binary.raw.decode(this._hasher.digest().data);
    }
}
